import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { GapBetweenIcons } from '../styles';
import Button from '../../../../../../../../shared/basic/Button';
import IconPlay from '../../../../../../../../shared/icon/IconPlay';
import { goTo } from '../../../../../../../../shared/helper/goTo';

const ButtonPlay = ({ id, isLoading, bgColor, color, ...props }) => {
  const handleClick = () => {
    if (id) goTo(`/audio/${id}`);
  };
  return (
    <Button
      tip="Go to audio"
      disabled={!id}
      onClick={handleClick}
      bgColor={bgColor || ''}
      color={isLoading ? 'transparent' : color || ''}
      {...props}
    >
      <GapBetweenIcons><IconPlay />Play</GapBetweenIcons>
    </Button>
  );
};

ButtonPlay.propTypes = {
  id: PropTypes.any,
  isLoading: PropTypes.bool,
};

ButtonPlay.defaultProps = {
  id: null,
  isLoading: false,
};

export default memo(ButtonPlay);
